import '.i{display:grid;}.ssr-plugin'
import '.a5{grid-template-columns:minmax(0, 1fr);}.ssr-plugin'
import '.h{gap:1.5rem;}.ssr-plugin'
import '.g{text-align:center;}.ssr-plugin'
import '.aa{color:var(--gray-500);}.ssr-plugin'
import '.a4{padding:2rem;}.ssr-plugin'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { useState } from 'react'
import { useQuery } from '@based/sdk/react'
import { KnowledgeHubModule } from '@schema/knowledgeHubModule'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'
import { SearchField } from '@app/components/blocks/searchBar/SearchField'
import Column from '@app/components/layout/Column'
import { PageLayout } from '../layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'

export const KnowledgeHub = () => {
  const t = useTranslations().app.knowledgeHubPage
  return (
    <PageLayout>
      <Title.H1 style={{ textAlign: 'center' }}>{t.title}</Title.H1>
      <KnowledgeHubItemsList />
    </PageLayout>
  )
}

export const KnowledgeHubItemsList = () => {
  const t = useTranslations().app.knowledgeHubPage
  const [, setLocation] = useLocation()
  const [searchBarInput, setSearchBarInput] = useState('')
  const [searchTerm, setSearchTerm] = useState('')

  const modulesQuery = useQuery('list-knowledge-hub-module', {
    searchTerm: searchTerm || undefined,
  })
  const modules: KnowledgeHubModule[] = modulesQuery.data ?? []

  return (
    <Column gap="1.5rem" alignItems="stretch">
      <SearchField
        placeholder={t.searchPlaceholder}
        searchBarInput={searchBarInput}
        searchTerm={searchTerm}
        setSearchBarInput={setSearchBarInput}
        setSearchTerm={setSearchTerm}
      />
      <styled.div className="i a5 h"
        style={{
          '@media (min-width: 800px)': {
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            '& > :nth-child(1)': {
              gridColumn: 'span 2',
            },
          },
        }}
      >
        {modules.map((item: KnowledgeHubModule) => (
          <BlogCard
            key={item.id}
            title={item.title}
            image={item.images?.[0]?.src}
            onClick={() => setLocation(pages.knowledgeHubModule(item.slug))}
          />
        ))}
      </styled.div>

      {modules.length === 0 && searchTerm && (
        <p className="g aa a4"
        >
          {t.noResults}
        </p>
      )}
    </Column>
  )
}
